import { useState, useEffect } from 'react'

import { getInitialAvatarSrc } from 'utils/ui'

import { getAvatarGen, checkLog } from './avatarService'

// Re-export from split modules for backward compatibility
export {
  EMAIL_STATE,
  TYPE,
  ACTION,
  ListenerObj,
  extendJmapState,
  isEqualData,
  applyData,
  sortByReceivedAt,
} from './defConstants'
export type { EmailData } from './defConstants'
export { getContactInfo, getAvatarURL } from './avatarService'

// Keep these imports for the default export object
import { TYPE, ACTION, ListenerObj, isEqualData, applyData, sortByReceivedAt } from './defConstants'
import { getAvatarURL } from './avatarService'

interface AvatarImgProps {
  name: string | null
  email: string
  clsName?: string
  alt?: string
  skipLogo?: boolean
  defaultSrc?: string
}

export function AvatarImg(props: AvatarImgProps) {
  const { name, email, clsName, alt, skipLogo } = props

  const [data] = useState<Record<string, unknown>>({})
  const [imgSrc, setImgSrc] = useState(getInitialAvatarSrc(name, email))

  useEffect(() => {
    const gen = getAvatarGen(name, email, skipLogo)
    data.isDefaultImg = true
    data.imgSrc = imgSrc

    if (gen.fixed === true) {
      data.isDefaultImg = false
      checkLog(email, ' - fixed - ', gen.fixUrl, data.imgSrc)
      if (gen.fixUrl !== data.imgSrc) {
        data.imgSrc = gen.fixUrl
        setImgSrc(data.imgSrc as string)
      }
    } else {
      if (gen.curUrl != null && gen.curUrl !== data.imgSrc) {
        data.isDefaultImg = false
        data.imgSrc = gen.curUrl
        setImgSrc(data.imgSrc as string)
      }

      data.listener = (url: string | null, fixed: boolean) => {
        data.isDefaultImg = false
        checkLog(email, ' - listener - ', url, data.imgSrc, fixed)
        if (url !== data.imgSrc) {
          data.imgSrc = url
          setImgSrc(data.imgSrc as string)
        }
      }

      gen.addListener(data.listener as (url: string | null, fixed: boolean) => void)

      if (gen.loading !== true) {
        gen.loading = true
        checkLog(email, ' - loading - ', gen.loading, data.imgSrc)
        gen.next(data.listener as (url: string | null, fixed: boolean) => void)
      }
    }

    return () => {
      // Your code you want to run on unmount.
      if (data.listener != null) {
        gen.removeListener(data.listener as (url: string | null, fixed: boolean) => void)
      }
    }
  }, [name, email])

  const onLoad = () => {
    const gen = getAvatarGen(name, email, skipLogo)
    checkLog(email, ' - onLoad - ', imgSrc, data.imgSrc)
    if (data.isDefaultImg === false) {
      gen.setFixed(imgSrc)
    }
  }

  const onError = () => {
    const gen = getAvatarGen(name, email, skipLogo)

    checkLog(email, ' - onError - ', imgSrc, data.imgSrc, gen.hasNext)

    if (gen.hasNext === true) {
      gen.fixed = false
      gen.next(data.listener as (url: string | null, fixed: boolean) => void)
    }
  }

  return <img className={clsName} src={imgSrc} alt={alt} onLoad={onLoad} onError={onError} />
}

const ext = {
  TYPE,
  ACTION,
  ListenerObj,
  isEqualData,
  applyData,
  sortByReceivedAt,
  getAvatarURL,
  AvatarImg,
}

export default ext
